import { useEffect, useState } from 'react'

export interface UseDebounceOpts {
  readonly delay?: number
  readonly skipInitialRender?: boolean
}

export function useDebounce<T>(
  value: T,
  opts: UseDebounceOpts = {}
): [T, boolean] {
  const { delay = 600, skipInitialRender = true } = opts

  const [debouncedValue, setDebouncedValue] = useState<T>(value)
  const [isDebouncing, setIsDebouncing] = useState<boolean>(false)
  const [initialRender, setInitialRender] = useState<boolean>(skipInitialRender)

  useEffect(() => {
    if (!skipInitialRender) return
    setInitialRender(false)
  }, [])

  useEffect(() => {
    if (initialRender) return
    setIsDebouncing(true)

    const timeout = setTimeout(() => {
      setDebouncedValue(value)
      setIsDebouncing(false)
    }, delay)

    return () => {
      clearTimeout(timeout)
    }
  }, [value])

  return [debouncedValue, isDebouncing]
}
